import _ from 'lodash';
import { DeliveryTypes } from '../../utils/constants';
import { createI18nObject } from '../../utils/i18nUtils';
import { FutureDelivery } from '@wix/wixrest-utils';

export function formatAddress(googleAddress) {
  return {
    formatted: googleAddress.formatted,
    latLng: { lat: _.get(googleAddress, 'location.latitude'), lng: _.get(googleAddress, 'location.longitude') },
    city: _.get(googleAddress, 'locality.long'),
    country: _.get(googleAddress, 'country.long'),
    countryCode: _.get(googleAddress, 'country.short'),
    number: _.get(googleAddress, 'streetNumber.long'),
    street: _.get(googleAddress, 'route.short'),
    postalCode: _.get(googleAddress, 'postalCode.short'),
  };
}

export function getDelayMins(organization) {
  const delivery = organization.deliveryInfos.find(di => di.type === DeliveryTypes.TAKEOUT);
  return _.get(delivery, 'delayMins');
}

export function getFormattedTimeGuarantee({ localDeliveryType, localAddress, t, organization }) {
  const cart = {
    delivery: {
      type: localDeliveryType,
    },
    isFutureOrder: false,
  };

  if (localDeliveryType === DeliveryTypes.DELIVERY) {
    cart.delivery.address = localAddress;
  }

  const i18n = createI18nObject(t, organization.locale);
  return FutureDelivery.timeGuaranteeText.getCartTimeGuaranteeText(organization, cart, i18n.get);
}
